import * as ol from 'openlayers'
import { DataTheme } from 'src/Enums'
import { DataforsyningenToken } from '../dataforsyningen/Dataforsyningen'
import { ContextTag } from '../wiki/Wiki'
import { GeoLayer, AbstractLayer, AbstractLayerOptions } from './Layer'
import { layerCopyrights, LayerDescription, LayerGroup, LayerParamsObject, LayerType } from './LayerRegistry'

/**
 * Map layer class for the TerrainShadows WMS source from Dataforsyningen.
 */
class TerrainShadows extends AbstractLayer implements GeoLayer {
  private static readonly token: string = DataforsyningenToken
  static readonly defaultParams: LayerParamsObject = {
    opacity: 0.8
  }

  constructor (options: any) {
    const defaultOptions: AbstractLayerOptions = {
      layerType: LayerType.TERRAIN_SHADOWS,
      enabled: true,
      minZoom: 12,
      zIndex: 1
    }
    super({ ...defaultOptions, ...options })

    let { opacity } = options.params
    opacity = opacity === undefined ? TerrainShadows.defaultParams.opacity : opacity

    this.olLayer = new ol.layer.Image({
      visible: this.enabled,
      opacity: opacity,
      source: new ol.source.ImageWMS({
        url: 'https://api.dataforsyningen.dk/wms/dhm_temp',
        params: {
          layers: 'quickDHM_skyggekort_terraen_overdrevet',
          token: TerrainShadows.token,
          transparent: 'TRUE'
        },
        projection: new ol.proj.Projection({
          code: 'EPSG:25832'
        }),
      })
    })
  }

  static describe (): LayerDescription {
    return {
      type: LayerType.TERRAIN_SHADOWS,
      name: 'map.layer.terrainshadows',
      group: LayerGroup.NEAR_TERRAIN,
      contextTags: [
        ContextTag.TERRAIN_SHADOWS
      ],
      themes: Object.values(DataTheme),
      capabilitiesUrl: '',
      legendEnabled: false,
      opacityEnabled: true,
      layerCopyright: layerCopyrights.Geodatastyrelsen
    }
  }
}

export default TerrainShadows
